class InfoBox {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.button = self.elem.querySelector('[data-info-box-button]');
        self.bubble = self.elem.querySelector('[data-info-box-bubble]');
        self.closeButton = self.elem.querySelector('[data-info-box-close-button]');
        self.onOutsideClick = self.onOutsideClick.bind(self);
        self.onEscape = self.onEscape.bind(self);
        self.isOpen = false;
    }

    init() {
        let self = this;

        self.button.addEventListener('click', evt => {
            if(self.isOpen) {
                self.close();
            } else {
                self.open();
            }
        });

        self.closeButton.addEventListener('click', evt => {
            self.close();
        });
    }

    open() {
        let self = this;

        self.bubble.classList.add('is-open');
        self.button.setAttribute('aria-expanded', true);
        self.addEventListeners();
        self.isOpen = true;
    }

    close() {
        let self = this;

        self.bubble.classList.remove('is-open');
        self.button.setAttribute('aria-expanded', false);
        self.removeEventListeners();
        self.isOpen = false;
    }

    addEventListeners() {
        let self = this;

        // Start listening for clicks outside the dropdown
        document.addEventListener('click', self.onOutsideClick);

        // Start listening for escape key press
        document.addEventListener('keydown', self.onEscape);
    }

    removeEventListeners() {
        let self = this;

        // Stop listening for clicks outside the dropdown
        document.removeEventListener('click', self.onOutsideClick);

        // Stop listening for escape key press
        document.removeEventListener('keydown', self.onEscape);
    }

    onOutsideClick(evt) {
        let self = this;

        // If the click was not on the dropdown or its children
        if (evt.target !== self.elem && !self.elem.contains(evt.target)) {

            // Close the dropdown
            self.close();
        }
    }

    onEscape(evt) {
        let self = this;

        if (evt.key === "Escape") {
            self.close();
        }
    }
}

export default InfoBox;
